export default "__VITE_ASSET__92a3bbb3__"